import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getWorkById, actionOnWork } from '../../services/Project';
import {
    Typography,
    Box,
    Grid,
    IconButton,
    CircularProgress,
    Tooltip,
    Card,
    Paper,
    Chip,
    Avatar,
    CardContent,
    Button,
    Stack,
    ToggleButton,
    ToggleButtonGroup
} from '@mui/material';
import {
    ArrowBack,
    MovieFilter,
    AccessTime,
    AssuredWorkload,
    Engineering,
    LocationOnOutlined,
    CalendarMonth,
    ThumbUp,
    Reply,
    Comment,
    Save

} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatBudgetAmount } from '../../../utils/formatBudgetAmount';
import currencyOption from "../../../data/currencies.json";
import DateChips from '../../../components/works/DateChips';
import ContactInfo from '../../../components/works/ContactInfo';
import ProjectDisplay from '../../../components/works/ProjectDisplay';
import { timeAgo, formatDate } from '../../../utils/TimeFormat';
import { formatDisplayName } from '../../../utils/formatDisplayName';
import { getImageUrlAdminToken } from '../../utills/ImagesUtilsAdmin';
//import InteractionBar from '../../../components/works/InteractionBar';


const WorkView = () => {
    const navigate = useNavigate();
    const { workId } = useParams();
    const [work, setWork] = useState(null);
    const [loading, setLoading] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);

    console.log("work", work);



    const handleAction = async (workId, action) => {
        if (!workId) return;
        setActionLoading(true);
        try {
            const response = await actionOnWork(workId, action);
            console.log('Action response:', response);
            // Optionally, you can navigate or show a success message here
            fetchWork();
        } catch (error) {
            console.error(`Error ${action}ing work:`, error);
        } finally {
            setActionLoading(false);
        }
    };



    const fetchWork = async () => {
        if (!workId) return;

        setLoading(true);

        try {
            const response = await getWorkById(workId);
            setWork(response.data[0]);
        } catch (err) {
            console.error('Error fetching work:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWork();
    }, [workId]);

    if (loading) {
        return (
            <Box sx={{ textAlign: "center", mt: 4 }}>
                <CircularProgress size={24} />
                <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
                    Loading ...
                </Typography>
            </Box>
        );
    }
    if (!work) return <div>No work found</div>;

    return (
        <React.Fragment >
            {loading ? (
                <Box sx={{ textAlign: "center", mt: 4 }}>
                    <CircularProgress />
                    <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
                        Loading ...
                    </Typography>
                </Box>
            ) : (
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                            <Box display="flex" alignItems="center" gap={0.2}>
                                <IconButton
                                    size="small"
                                    color="inherit"
                                    aria-label="back"
                                    onClick={() => navigate(-1)}
                                    sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
                                >
                                    <Tooltip title="Back to previous page" arrow>
                                        <ArrowBack />
                                    </Tooltip>
                                </IconButton>
                                <Typography variant="h5" fontWeight={500}>
                                    {work?.title}
                                </Typography>
                            </Box>



                        </Box>



                        <Box>
                            <Box display="flex" alignItems="center" flexWrap="wrap" justifyContent="space-between">
                                <div>
                                    <Chip
                                        label={formatDisplayName(work?.user?.name, {
                                            maxLength: 25,
                                            truncateAtSpace: true,
                                        })}
                                        avatar={
                                            <Avatar
                                                src={getImageUrlAdminToken(work.user.thumbnail_pic)}
                                                alt={work.user.name}
                                                sx={{ border: '1px solid', borderColor: 'divider' }}
                                            />
                                        }
                                        size="small"
                                        clickable
                                        onClick={() => navigate(`/users/${work.user_id}`)}
                                        sx={{ backgroundColor: 'transparent', borderRadius: 1 }}
                                    />
                                    <Typography variant="caption" color="text.secondary">
                                        • {`${timeAgo(work.created_at)} ago`} •
                                        <span
                                            style={{
                                                color: work.status === 1 ? 'green' : work.status === 0 ? 'red' : 'orange',
                                                marginLeft: '5px',
                                                fontSize: '0.9em',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {work.status === 1 ? 'Open' : work.status === 0 ? 'Closed' : 'Restricted By Admin'}
                                        </span>
                                        {work.is_urgent === 1 && (
                                            <>
                                                {' '} •
                                                <span style={{ color: 'red', marginLeft: '5px', fontSize: '0.9em', fontWeight: 'bold' }}>
                                                    Urgent
                                                </span>
                                            </>
                                        )}
                                    </Typography>
                                </div>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                        gap: 1,
                                        justifyContent: { xs: 'space-between', sm: 'flex-end' },
                                        width: { xs: '100%', sm: 'auto' },
                                    }}
                                >
                                    {work.end_date && (
                                        <Button
                                            variant="text"
                                            size="small"
                                            color="error"
                                            sx={{ textTransform: 'none', padding: '3px 6px' }}
                                        >
                                            {'Last date: ' + formatDate(work.end_date)}
                                        </Button>
                                    )}
                                    <Stack sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', gap: 1 }}>
                                        <Tooltip title="Total Likes" placement='top' arrow>
                                            <Chip
                                                label={work.people_action_data.reactionCounts}
                                                size="small"
                                                disabled
                                                clickable={false}
                                                icon={<ThumbUp />}
                                                sx={{
                                                    backgroundColor: 'transparent',
                                                    "&:hover": { backgroundColor: 'transparent' },
                                                    '& .MuiChip-icon': {
                                                        color: work.isLiked ? 'primary.main' : 'text.secondary',
                                                    },
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Total Comments" placement='top' arrow>
                                            <Chip
                                                label={work.people_action_data.commentCounts}
                                                size="small"
                                                disabled
                                                icon={<Comment />}
                                                sx={{
                                                    backgroundColor: 'transparent',
                                                    "&:hover": { backgroundColor: 'transparent' },
                                                    '& .MuiChip-icon': {
                                                        color: 'text.secondary',
                                                    },
                                                }}
                                            />
                                        </Tooltip>
                                        <Tooltip title="Total Shares" placement='top' arrow>
                                            <Chip
                                                label={work.people_action_data.shareCounts}
                                                disabled
                                                size="small"
                                                icon={<Reply />}
                                                sx={{
                                                    backgroundColor: 'transparent',
                                                    "&:hover": { backgroundColor: 'transparent' },
                                                    '& .MuiChip-icon': {
                                                        color: 'text.secondary',
                                                        transform: 'scaleX(-1)',
                                                    },
                                                }}
                                            />
                                        </Tooltip>
                                    </Stack>
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>

                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                    {/* <strong>Work Status: </strong> */}
                                    <Tooltip title="Job Status By Admin" arrow placement="top">
                                        <Chip
                                            variant="contained"
                                            color='primary'
                                            label={work.admin_work_status}
                                            size="small"
                                            onClick={() => { }}
                                            clickable={false}
                                            sx={{
                                                fontWeight: 500,
                                                textTransform: 'capitalize',
                                            }}

                                        />
                                    </Tooltip>
                                </Typography>
                            </Box>


                            <Stack sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                <Tooltip title="Approve Job" arrow placement='top'>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        disableElevation
                                        sx={{ textTransform: 'none', padding: '5px 30px' }}
                                        onClick={() => handleAction(workId, 'Approved')}
                                        disabled={actionLoading || work.admin_work_status === 'Approved'}
                                    >
                                        Approve
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Restrict Job" arrow placement='top'>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        disableElevation
                                        sx={{ textTransform: 'none', padding: '5px 25px' }}
                                        onClick={() => handleAction(workId, 'Restricted')}
                                        disabled={actionLoading || work.admin_work_status === 'Restricted'}
                                    >
                                        Restrict
                                    </Button>
                                </Tooltip>
                            </Stack>


                        </Box>
                    </Grid>

                    <Grid size={{ xs: 7, sm: 6, md: 4 }}>
                        <Card elevation={0} sx={{ p: 1.5, height: '100%' }}>
                            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', pb: 1, fontWeight: 500 }}>
                                <MovieFilter sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '22px', }} />
                                Type
                            </Typography>

                            <Typography variant="body2">
                                <Typography variant="body2">
                                    <Typography variant="body2">
                                        {work.work_project_type.map(type => type.project_type_name)}
                                    </Typography>
                                </Typography>
                            </Typography>
                        </Card>
                    </Grid>

                    <Grid size={{ xs: 5, sm: 6, md: 3 }}>
                        <Card elevation={0} sx={{ p: 1.5, height: '100%' }}>
                            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', pb: 1, fontWeight: 500 }}>
                                <AccessTime sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '22px', }} />
                                {"Duration" + (work.duration > 1 ? "s" : "")}
                            </Typography>
                            <Typography variant="body2">
                                {work.duration} {work.duration > 1 ? "days" : "day"}
                            </Typography>
                        </Card>
                    </Grid>

                    <Grid size={{ xs: 5, sm: 6, md: 5 }}>
                        <Card elevation={0} sx={{ p: 1.5, height: '100%' }}>
                            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', pb: 1, fontWeight: 500 }}>
                                <AssuredWorkload sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '22px', }} />
                                Budget
                            </Typography>
                            <Typography variant="body2">
                                {formatBudgetAmount(work.budget, currencyOption)}
                            </Typography>
                        </Card>
                    </Grid>


                    <Grid size={{ xs: 7, sm: 6, md: 3 }}>
                        <Card elevation={0} sx={{ p: 1.5, height: '100%' }}>
                            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', pb: 1, fontWeight: 500 }}>
                                <Engineering sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '22px', }} />
                                {"Role" + (work.work_roles.length > 1 ? "s" : "")}
                            </Typography>

                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {work.work_roles.map((role, index) => (
                                    <Paper
                                        variant='outlined'
                                        key={index}
                                        sx={{ display: 'flex', boxShadow: 'none', alignItems: 'center', borderRadius: 5, backgroundColor: 'background.paper' }}
                                    >
                                        <Chip clickable={false}
                                            onClick={() => { }}
                                            avatar={<Avatar />}
                                            label={role.role_name}
                                            color='inherit'
                                            size="small"
                                            sx={{
                                                backgroundColor: 'background.default',
                                                maxWidth: '180px', // Explicit max width
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap', // Ensure single-line text
                                            }}
                                        />
                                    </Paper>
                                ))}
                            </Box>
                        </Card>
                    </Grid>


                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                        <Card elevation={0} sx={{ p: 1.5, height: '100%' }}>
                            <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', pb: 1, fontWeight: 500 }}>
                                <LocationOnOutlined sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '22px', }} />
                                {"Location" + (work.locations.length > 1 ? "s" : "")}
                            </Typography>

                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {work.locations.map((loc, index) => (
                                    <Paper
                                        variant="outlined"
                                        key={index}
                                        sx={{
                                            display: 'flex',
                                            boxShadow: 'none',
                                            alignItems: 'center',
                                            borderRadius: 5,
                                            backgroundColor: 'background.paper',
                                        }}
                                    >
                                        <Tooltip title={`${loc.city}, ${loc.country}`} arrow placement='top'>
                                            <Chip
                                                clickable={false}
                                                onClick={() => { }}
                                                avatar={<Avatar>{loc.city.charAt(0).toUpperCase()}</Avatar>}
                                                label={`${loc.city}, ${loc.country}`}
                                                color="inherit"
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'background.default',
                                                    maxWidth: '180px', // Explicit max width
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap', // Ensure single-line text
                                                }}
                                            />
                                        </Tooltip>
                                    </Paper>
                                ))}
                            </Box>
                        </Card>
                    </Grid>

                    {work.shoot_date.length > 0 && (
                        <Grid size={{ xs: 12, sm: 6, md: 5 }}>
                            <Card elevation={0} sx={{ p: 1.5, height: '100%' }}>
                                <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', pb: 1, fontWeight: 500 }}>
                                    <CalendarMonth sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '22px', }} />
                                    {"Date" + (work.shoot_date.length > 1 ? "s" : "")}
                                </Typography>
                                <DateChips data={work.shoot_date} detailview={true} />
                            </Card>
                        </Grid>
                    )}




                    {(work.description || work.contact_info || work.project_id) && (
                        <Grid size={12}>
                            <Card sx={{ p: 1.5 }} elevation={0}>
                                {work.description && (
                                    <>
                                        <Typography variant="body1" fontWeight={500} gutterBottom>
                                            Job Description
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {work.description}
                                        </Typography>
                                    </>
                                )}
                                {work.project_id && (
                                    <>
                                        <Typography variant="body1" fontWeight={500} gutterBottom sx={{ mt: 2 }}>
                                            Project Details
                                        </Typography>
                                        <ProjectDisplay project={work.project_id} />
                                    </>
                                )}

                                {work.contact_info && (
                                    <>
                                        <Typography variant="body1" fontWeight={500} gutterBottom sx={{ mt: 2 }}>
                                            Contact Information
                                        </Typography>
                                        <ContactInfo contact_info={work.contact_info} />
                                    </>
                                )}
                            </Card>
                        </Grid>
                    )}
                </Grid>
            )}

        </React.Fragment>
    );
};
export default WorkView;
